import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyNumber'
})
export class PrettyNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(value);
  }

}
